<template>
  <div>
    <v-dialog v-model="show_dialog_box" max-width="600px">
      <template v-slot:activator="{ on }">
        <v-row class="ms-1">
          <v-btn :disabled="!isAddress" class="mt-4 mb-8 text-capitalize font-weight-bold " color="primary" v-on="on"> <v-icon class="me-1" small>mdi-plus</v-icon>Add </v-btn>
          <h5 v-if="!isAddress" class="mt-4 error--text ms-2">
            No address found
          </h5>
        </v-row>
      </template>

      <v-spacer></v-spacer>
      <v-card class="pa-3" color="pop_bg">
        <v-row>
          <v-card-title class="text-h6 dark--text mt-n2">Delivery Schedule</v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="dark" text @click="close"><v-icon>mdi-close</v-icon></v-btn>
        </v-row>
        <v-divider class="mt-n2"></v-divider>
        <v-form @submit.prevent="createDeliverySchedule()" v-model="valid" ref="form" class="pa-6 pa-sm-8">
          <!-- Selection for Schedule Type -->
          <v-layout wrap class="ms-2 mb-4">
            <v-flex xs12 md3>
              <h4 class="font-weight-medium text-body-2 dark--text">Type</h4>
            </v-flex>
            <v-flex xs12 md8>
              <v-radio-group v-model="scheduleType" row class="mt-0">
                <v-radio label="Weekly Days" value="WEEKDAYS"></v-radio>
                <v-radio label="Date Range" value="DATE_RANGE"></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>

          <!-- Weekday select dropdown (for WEEKDAYS scheduleType) -->
          <v-layout wrap class="ms-2" v-if="scheduleType === 'WEEKDAYS'">
            <v-flex xs12 md3>
              <h4 class="font-weight-medium text-body-2 dark--text">Week Days</h4>
            </v-flex>
            <v-flex xs12 md8>
              <v-select
                v-model="selectedWeekdays"
                :items="listOfDays"
                multiple
                chips
                solo
                dense
                :rules="[requiredValidator('weekdays')]"
                label="Select Days"
              ></v-select>
            </v-flex>
          </v-layout>

          <!-- Date Picker range inputs (for DATE_RANGE scheduleType) -->
          <v-layout wrap class="ms-2" v-if="scheduleType === 'DATE_RANGE'">
            <v-flex xs12 md3>
              <h4 class="font-weight-medium text-body-2 dark--text">Date Range</h4>
            </v-flex>
            <v-flex xs12 md4 class="pe-2">
              <v-menu
                v-model="menuStartDate"
                :close-on-content-click="false"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="startDate"
                    label="Start Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    solo
                    dense
                    :rules="[requiredValidator('Start Date')]"
                  ></v-text-field>
                </template>
                <v-date-picker
                  color="primary"
                  v-model="startDate"
                  @input="menuStartDate = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 md4 class="ps-2">
              <v-menu
                v-model="menuEndDate"
                :close-on-content-click="false"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="endDate"
                    label="End Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    solo
                    dense
                    :rules="[requiredValidator('End Date')]"
                  ></v-text-field>
                </template>
                <v-date-picker
                  color="primary"
                  v-model="endDate"
                  @input="menuEndDate = false"
                  :min="startDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>

          <v-row class="mx-2 mt-4 mb-4" justify="space-between" align="end">
            <h4 class="dark--text text-h6">Address</h4>
          </v-row>
          <div v-for="address in addressList" :key="address._id">
            <v-row class="mb-n6 mt-n5" justify="end">
              <v-radio-group v-model="selectdAddress" :rules="[requiredValidator('address')]">
                <v-radio :value="address._id"></v-radio>
              </v-radio-group>
            </v-row>
            <v-row class="mb-n6 mt-n14">
              <v-col class="ms-2 text-body-2 dark--text" md="5">Area</v-col>
              <v-col md="6" class="font-weight-medium text-body-2 dark--text">
                {{ address.area.nameEn }}
              </v-col>
            </v-row>

            <v-row class="mb-n6">
              <v-col md="5" class="ms-2 text-body-2 dark--text">Block</v-col>
              <v-col md="6" class="font-weight-medium text-body-2 dark--text" v-if="address.block">{{ address.block.block }}</v-col>
            </v-row>

            <v-row class="mb-n6">
              <v-col md="5" class="ms-2 text-body-2 dark--text">Street</v-col>
              <v-col md="6" class="font-weight-medium text-body-2 dark--text">{{ address.street }}</v-col>
            </v-row>

            <v-row class="mb-n6">
              <v-col md="5" class="ms-2 text-body-2 dark--text">Jedha</v-col>
              <v-col md="6" class="font-weight-medium text-body-2 dark--text">{{ address.jedha }}</v-col>
            </v-row>

            <v-row class="mb-n6">
              <v-col class="ms-2 text-body-2 dark--text" md="5">House number</v-col>
              <v-col md="6" class="font-weight-medium text-body-2 dark--text">{{ address.house_number }}</v-col>
            </v-row>

            <v-row class="mb-6">
              <v-col class="ms-2 text-body-2 dark--text" md="5">Floor number</v-col>
              <v-col md="6" class="font-weight-medium text-body-2 dark--text">
                {{ address.building_number }}
              </v-col>
            </v-row>
          </div>

          <v-layout row class="mt-8 mb-n5">
            <v-spacer></v-spacer>
            <v-btn color="primary" class=" light--text text-capitalize" width="120" @click="createDeliverySchedule()" :loading="btnloading" :disabled="!valid">Save</v-btn>
          </v-layout>
        </v-form>
        <v-snackbar v-model="snackbar" timeout="3000" right top :color="snackbarColor">{{ text }}</v-snackbar>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { required } from "vee-validate/dist/rules";
import { requiredValidator } from "../../../core/methods/validations";
import { extend, setInteractionMode } from "vee-validate";
setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} cannot be empty",
});
export default {
  components: {},

  data() {
    return {
      selectdAddress: null,
      addressList: [],
      listOfDays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      week: "",
      scheduleType: "WEEKDAYS",
      selectedWeekdays: [],
      startDate: "",
      endDate: "",
      menuStartDate: false,
      menuEndDate: false,
      selectPackage: "",
      choice: "",
      start_date: "",
      menu1: false,
      snack: false,
      snackColor: "",
      snackText: "",
      isValidIngredient: true,
      requiredValidator: requiredValidator,
      show_dialog_box: false,
      btnloading: false,
      valid: true,
      isAddress: false,
      errors: [],
      snackbar: false,
      text: "",
      snackbarColor: "",
      variables: {
        limit: 25,
        skip: 0,
      },
      packagesList: [],
    };
  },

  created() {
    this.getCustomerDetails();
  },
  watch: {
    "$route.query.customerId": {
      handler() {
        this.getCustomerDetails();
      },
    },
  },
  methods: {
    defaultAddress() {
      return this.customer.addressDetails;
    },
    getCustomerDetails() {
      this.$apollo
        .query({
          query: require("../../api/getCustomerById.graphql"),
          variables: {
            id: this.$route.query.customerId,
          },
        })
        .then(data => {
          this.loading = false;

          if (data.data.getCustomerById) {
            this.customer = data.data.getCustomerById;
            this.addressList = this.customer.addressDetails;
            if (this.addressList.length > 0) {
              this.isAddress = true;
              this.selectdAddress = this.addressList[0]._id;
            }
          }
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
    async createDeliverySchedule() {
      this.btnloading = true;
      try {
        if (this.scheduleType === "WEEKDAYS") {
          if (!this.selectedWeekdays || this.selectedWeekdays.length === 0) {
            throw new Error("Please select at least one week day");
          }
          for (const day of this.selectedWeekdays) {
            await this.$apollo.mutate({
              mutation: require("../../api/createDeliverySchedule.graphql"),
              variables: {
                customer: this.$route.query.customerId,
                week: day,
                address: this.selectdAddress,
                type: "WEEKDAYS"
              },
              update: (store, { data: { createDeliverySchedule } }) => {
                try {
                  const query = {
                    query: require("../../api/getDeliveryScheduleByCustomerId.graphql"),
                    variables: {
                      id: this.$route.query.customerId,
                    },
                  };

                  let allDeliverySchedule = store.readQuery(query);
                  if (!allDeliverySchedule.getDeliveryScheduleByCustomerId.some(x => x._id === createDeliverySchedule._id)) {
                    allDeliverySchedule.getDeliveryScheduleByCustomerId.unshift(createDeliverySchedule);
                  }
                  store.writeQuery({
                    ...query,
                    data: allDeliverySchedule,
                  });
                } catch (e) {
                  console.log(e);
                }
              },
            });
          }
          this.text = "Delivery Schedules Added";
        } else {
          // DATE_RANGE
          if (!this.startDate || !this.endDate) {
            throw new Error("Please select start and end dates");
          }
          await this.$apollo.mutate({
            mutation: require("../../api/createDeliverySchedule.graphql"),
            variables: {
              customer: this.$route.query.customerId,
              week: "",
              address: this.selectdAddress,
              type: "DATE_RANGE",
              startDate: this.startDate,
              endDate: this.endDate
            },
            update: (store, { data: { createDeliverySchedule } }) => {
              try {
                const query = {
                  query: require("../../api/getDeliveryScheduleByCustomerId.graphql"),
                  variables: {
                    id: this.$route.query.customerId,
                  },
                };

                let allDeliverySchedule = store.readQuery(query);
                allDeliverySchedule.getDeliveryScheduleByCustomerId.unshift(createDeliverySchedule);
                store.writeQuery({
                  ...query,
                  data: allDeliverySchedule,
                });
              } catch (e) {
                console.log(e);
              }
            },
          });
          this.text = "Delivery Schedule Added";
        }
        this.snackbarColor = "success";
        this.snackbar = true;
        this.$refs.form.reset();
        this.selectedWeekdays = [];
        this.startDate = "";
        this.endDate = "";
        this.show_dialog_box = false;
      } catch (error) {
        if (error.graphQLErrors != null && error.graphQLErrors.length > 0) {
          console.error(error.graphQLErrors);
          if (error.graphQLErrors[0].message === "ALREADY_EXIST") {
            this.text = "Schedule already exists for the selected day/date range";
          } else {
            this.text = "Failed to add delivery schedule";
          }
        } else {
          this.text = error.message || "Something went wrong";
        }
        this.snackbarColor = "error";
        this.snackbar = true;
      } finally {
        this.btnloading = false;
      }
    },
    close() {
      this.show_dialog_box = false;
    },
  },
};
</script>
